import React from "react";
import classNames from "classnames";
import { MenuTab, useMenuTabStore } from "@/store/menuTabStore";
import cls from "./styles.module.scss";
import { dataTrigger, type Trigger } from "@/analytics";

const tabs: { id: MenuTab; name: string }[] = [
  { id: "invite", name: "Приглашать" },
  { id: "statistics", name: "Статистика" },
];

const TAB_TRIGGERS: Record<MenuTab, Trigger> = {
  invite: "ref.main.tab_invite",
  statistics: "ref.main.tab_statistics",
};

export const TabsMenu = () => {
  const activeTab = useMenuTabStore((s) => s.activeTab);
  const setActiveTab = useMenuTabStore((s) => s.setActiveTab);

  return (
    <div className={cls.tabs}>
      {tabs.map(({ id, name }) => (
        <button
          key={id}
          type="button"
          {...dataTrigger(TAB_TRIGGERS[id])}
          className={classNames(
            cls.tab,
            activeTab === id ? cls.activeTab : undefined
          )}
          onClick={() => setActiveTab(id)}
        >
          {name}
        </button>
      ))}
    </div>
  );
};
